/*
 File: toast-alert.js
 Author: D McCleod
 Created: 2/22/2017
 Modified:
 Description: display toast alert when user first loads slide on break point 1 or 2 only. Fade on tap or 3 seconds.
 */


var toast = {};
toast.message = $('.crs-col_toast');

toast.timeID = null;

// click event is being block by arrows, because they are higher up in the dom, preventing event from firing :\
// better to request the toast only be only one element above arrows and remove from individual slides
// TODO: toast can be removed from template so js will not need to do the check


toast.init = function() {
    toast.message.on('click', toast.removeToast);
    toast.fadeInToast();
};

toast.timer = function(){
    return ( toast.timeID = setTimeout(toast.fadeOutToast, 3000)) ;
};

toast.fadeInToast = function() {
    toast.isVisible = true;
    toast.message.animate({opacity: 1},{
        duration: 700,
        complete: toast.timer
    });
};

toast.fadeOutToast = function(){
    toast.isVisible = false;
    clearTimeout(toast.timeID);
    toast.message.fadeTo(300, 0, toast.removeToast);
};

toast.removeToast = function(){
    toast.message.remove();
    $(window).trigger('toast:removed');
};


// TODO: prototype, if toast is needed on inifinitescroll, would need to be called in toast.init()
/*
toast.onInfiniteScroll = function() {
    toast.message.html('SCROLL').promise().done(function(){
        var slideNumber = getHash(),
            slideImage = $('[data-slidenumber='+ slideNumber +'] .crs-slide_image'),
            topPos = Math.round(slideImage.offset().top + (slideImage.height() * 0.35) );

        if(slideNumber === imageCount) {
            toast.message.addClass('last-toast');
            topPos = Math.round(slideImage.offset().top - slideImage.height());
        }

        toast.message.css('top', topPos);
        toast.fadeInToast();
    });
};
*/

export { toast };